import { SET_EMAILS, CLEAR_EMAILS, SET_STORED_EMAILS } from "../actions/emailActions";

const initialState = {
  emails: [],
  storedEmails: []
}

function emailReducer(state = initialState, action) {
  switch (action.type) {
  case SET_EMAILS:
    return {
      ...state,
      emails: action.payload
    }
  case CLEAR_EMAILS:
    return {
      ...state,
      storedEmails: [],
      emails: []
    }
  case SET_STORED_EMAILS:
    return {
      ...state,
      storedEmails: action.payload,
    }
  default:
    return state;
  }
}

export default emailReducer;